import { useStaticQuery, graphql } from "gatsby"

export  const useStrapiToolKitData = () => {
    const { allStrapiToolkitModule } = useStaticQuery(graphql`
      query {
        allStrapiToolkitModule {
          nodes {
            slug
            card_description
            card_title
            full_module {
              name
              localFile {
                prettySize
              }
            }
            thumbnail {
              alternativeText
              localFile {
                childImageSharp {
                  gatsbyImageData
                }
              }
            }
          }
        }
      }
    `)

    return { allStrapiToolkitModule }
}
